import React, { Component } from 'react'
import 'whatwg-fetch'

import { FlexContainer } from '../../styles/defaults'
import Module from '../../components/Module/'

import helpers from '../../helpers'

class Modules extends Component {
  constructor(props) {
    super(props)
    this.state = {
      notices: [],
      appointments: [],
      messages: []
    }
  }

  componentDidMount() {
    const { portalOrder, errors, messages, servicePackage, nextDeliveryDate, suspended } = this.props
    const { notices, appointments } = helpers.getNotifications(portalOrder, errors, messages, servicePackage, nextDeliveryDate, suspended)
    this.setState({ notices, appointments })

    const url = process.env.REACT_APP_HOST_ENV === 'production'
    ? 'https://kaarskoffie.nl'
    : process.env.REACT_APP_HOST_ENV === 'staging'
      ? 'https://kaarskoffie.nl'
      : 'http://localhost:3000'

    window.fetch(`${url}/wp-json/wp/v2/portalmessage`).then((response) => {
      return response.json()
    }).then((r) => {
      this.setState({ messages: r })
    })
  }

  render() {
    const { notices, appointments, messages } = this.state
    const { permissions, role } = this.props

    let viewNotifications = permissions.includes('VIEW_NOTIFICATIONS') || role === 'MANAGER'
    let viewAgenda = permissions.includes('VIEW_AGENDA') || role === 'MANAGER'
    return (
      <FlexContainer mb>
        {viewNotifications ? <Module full={viewAgenda} title="Meldingen" notices={notices} /> : null}
        {viewAgenda ? <Module full={viewNotifications} title="Agenda" appointments={appointments} /> : null}
        {viewNotifications ? <Module full={false} title="Nieuws" messages={messages} /> : null}
      </FlexContainer>
    )
  }
}

export default Modules



// WEBPACK FOOTER //
// ./src/containers/Modules/index.js